import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-3, envelope"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.13867 9.35425C5.62141 11.1748 8.68498 12.25 11.9997 12.25C15.3143 12.25 18.3779 11.1748 20.8606 9.35425" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEmail3;
